import type { ObjectValues } from '@repo/common';

export const MobileRedirectStep = {
  SCAN: 'SCAN',
  TUTORIAL: 'TUTORIAL',
  PENDING: 'PENDING',
  ERROR: 'ERROR',
} as const;

export type MobileRedirectStepValues = ObjectValues<typeof MobileRedirectStep>;
